import axios from '../axios'

export const selectByPage = (data) => {
    return axios({
        url: '/admin/platformActivity/selectByPage',
        method: 'post',
        data
    })
}
export const insert = (data) => {
    return axios({
        url: '/admin/platformActivity/insert',
        method: 'post',
        data
    })
}
export const update = (data) => {
    return axios({
        url: '/admin/platformActivity/update',
        method: 'post',
        data
    })
}
export const batchUpdateStatus = (data) => {
    return axios({
        url: '/admin/platformActivity/batchUpdateStatus',
        method: 'post',
        data
    })
}

export const batchDelete = (data) => {
    return axios({
        url: '/admin/platformActivity/batchDelete',
        method: 'post',
        data
    })
}


// WEBPACK FOOTER //
// ./src/http/moudules/platformActivity.js